/**
 * sidebarConfig
 *
 * Centralized sidebar configuration for every navigation level.
 * The sidebar reads the current URL, matches it against these configs,
 * and renders the appropriate items autonomously.
 *
 * Levels are ordered most-specific-first so that `matchPath` hits the
 * deepest match before falling back to broader patterns.
 */

import { cageLevel } from './cageLevel';
import { internalLevel } from './internalLevel';
import { locationLevel } from './locationLevel';
import { regionLevel } from './regionLevel';
import type { SidebarLevelConfig } from './types';
import { woundsLevel } from './woundsLevel';

export type {
    SidebarItemConfig,
    SidebarLevel,
    SidebarLevelConfig,
    VisibilityConfig,
    VisibilityRules,
} from './types';

/** Every navigation level, most specific first. */
export const sidebarLevels: SidebarLevelConfig[] = [
    woundsLevel,
    cageLevel,
    locationLevel,
    regionLevel,
    internalLevel,
];
